import { useEffect, useState } from 'react';
import { goApi } from '../services';

type UseBatchByIdProps = {
    id: string;
};

const useBatchById = ({ id }: UseBatchByIdProps) => {
    const [batch, setBatch] = useState<any>(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState<string | null>(null);

    const fetchBatch = async () => {
        try {
            setLoading(true);
            setError(null);

            const data = await goApi.get(`/batches/${id}`);

            setBatch(data?.data || null);
        } catch (err: any) {
            setError(err.message || 'Failed to fetch batch');
        } finally {
            setLoading(false);
        }
    };

    useEffect(() => {
        if (id) {
            fetchBatch();
        }
    }, [id]);

    return { batch, loading, error, refetch: fetchBatch };
};

export default useBatchById;
